import cn from 'classnames';
import styles from './styles.scss';

interface OwnProps {
  day: Date;
  currentMonth: boolean;
  isDayWeekend?: boolean;
}

export const NotSelectableDay = ({ day, currentMonth, isDayWeekend }: OwnProps) => {
  return (
    <span
      className={cn(styles.day, {
        [styles.notCurrentMonth]: !currentMonth,
        [styles.weekend]: isDayWeekend
      })}
    >
      {day.getDate()}
    </span>
  );
};
